<template>
    <div class="sticky top-0 z-10" data-testid="select-search">
        <span
            class="absolute shrink-0 inset-y-0 left-0 flex items-center justify-center w-9 pointer-events-none"
            data-testid="search-icon"
        >
            <interface-search
                class="text-gray-400"
                :class="oldFontScale ? 'h-3.5 w-3.5' : 'h-3 w-3'"
            />
        </span>
        <input
            class="form-input pl-9 pr-3 w-full border-0 text-base | focus:ring-0"
            :class="{ 'sm:text-sm': !oldFontScale }"
            data-testid="search-input"
            type="text"
            :value="value"
            ref="inputRef"
            @keydown.enter.prevent.stop="emit('enter', $event)"
            @input="onInput"
        />
    </div>
</template>

<script lang="ts" setup>
    import { inject, ref } from 'vue';
    import InterfaceSearch from '@/components/activix-ui/ActivixSelect/assets/interface-search.svg';

    defineOptions({ compatConfig: { MODE: 3 } });

    defineProps<{
        value: string;
    }>();

    const emit = defineEmits<{
        (event: 'input', value: string): void;
        (event: 'enter', value: KeyboardEvent): void;
    }>();

    const oldFontScale = inject<boolean>('oldFontScale', true);
    const inputRef = ref<HTMLInputElement | null>(null);

    const onInput = (event: Event) => {
        emit('input', (event.target as HTMLInputElement).value);
    };

    const focus = () => {
        inputRef.value?.focus();
    };

    const isFocused = () => {
        return document.activeElement === inputRef.value;
    };

    defineExpose({
        focus,
        isFocused,
    });
</script>
